import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface Item {
  id: string;
  listTitle: string;
  listDescription: string;
}

interface LayoutTextInputProps {
  items: Item[];
  editItemPopup: (id: string) => void;
  handleRemoveItem: (id: string) => void;
}

export const LayoutTextInput = ({ items, editItemPopup, handleRemoveItem }: LayoutTextInputProps) => {
  const { isEditable } = useContext(CreateArtifactContext);

  const getAspectRatio = (imagePreview: string) => {
    if (imagePreview) {
      const img = new Image();
      img.src = imagePreview;
      return img.naturalWidth / img.naturalHeight;
    }
    return 1;
  };

  const getContainerStyle = (imagePreview: string) => {
    const aspectRatio = getAspectRatio(imagePreview);
    return `h-[${100 / aspectRatio}%]`;
  };

  return (
    <table className="w-full">
      <tbody>
        {items.map(item => (
          <tr key={item.id} className="relative mb-[30px]">
            <td className="flex flex-col space-y-[6px]">
              <div className="pb-[7px] flex justify-between items-center">
                <span className="list_item_title">{item.listTitle}</span>
              </div>
              <div className="list_item_sub_title">{item.listDescription}</div>
              <div className="flex flex-col ml-auto">
                {isEditable && (
                  <div className="flex max-w-[480px]">
                    <div className="absolute content-center w-5 h-5 align-middle shadow-md top-4 right-4 rounded-3xl bg-slate-600">
                      <button className="absolute top-0 left-0 right-0 text-white" onClick={() => handleRemoveItem(item.id)}>
                        ×
                      </button>
                    </div>
                    <div className="absolute content-center w-5 h-5 align-middle shadow-md top-10 right-4 rounded-3xl bg-slate-600">
                      <button
                        className="relative flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600"
                        onClick={() => editItemPopup(item.id)}
                      >
                        ✎
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </td>
            <div className="thinseparator mt-[15px] mb-[15px]" />
          </tr>
        ))}
      </tbody>
    </table>
  );
};
